import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.concat.js";

/*----------------------------------------------------*/
// Dependencies

/*----------------------------------------------------*/
import { performance, app, register, attach } from './core';
import { functionName, isElement as _isElement, cloneDeep as _cloneDeep } from './utils';
/*----------------------------------------------------*/
// Constants & variables

/*----------------------------------------------------*/

var UID = 0;
var PLUGINS = [];
var defaults = {
  $: Object.create(null),
  $$: Object.create(null)
};
var properties = {
  debug: __DEV__,
  _initialized: false,
  $: Object.create(null),
  $$: Object.create(null),
  promises: Object.create(null),
  timers: Object.create(null),
  bounds: Object.create(null)
};
/*----------------------------------------------------*/
// Functions

/*----------------------------------------------------*/

/*----------------------------------------------------*/
// Module

/*----------------------------------------------------*/

var Component = /*#__PURE__*/function () {
  function Component() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Object.create(null);

    _classCallCheck(this, Component);

    // properties
    Object.assign(this, _cloneDeep(properties)); // options

    this.options = Object.assign(Object.create(null), defaults, options); // remove useless prototypes

    if (typeof Object.setPrototypeOf !== 'undefined') {
      Object.setPrototypeOf(this.options, null);
      Object.setPrototypeOf(this.options.$, null);
      Object.setPrototypeOf(this.options.$$, null);
    } // component internal properties


    this.app = app();
    this._name = options.name || this._name;

    if (typeof this._name === 'undefined') {
      return false;
    }

    UID += 1;
    this._uid = UID; // attach plugins

    attach(PLUGINS, this);
    return this;
  }

  _createClass(Component, [{
    key: "init",
    value: function init(options) {
      this._initialized = true;
      return this;
    } // Helpers
    // --------------------------------------------------

  }, {
    key: "$select",
    value: function $select($rootElm) {
      this.$ = $rootElm.$select(this.options.$);
      this.$$ = this.options.$$;
    } // Static
    // --------------------------------------------------

  }], [{
    key: "isElement",
    value: function isElement(element) {
      return _isElement(element);
    }
  }, {
    key: "cloneDeep",
    value: function cloneDeep(object) {
      return _cloneDeep(object);
    }
  }, {
    key: "use",
    value: function use() {
      var module = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      register.apply(void 0, [PLUGINS, module].concat(args));
    }
  }]);

  return Component;
}();

export default Component;

if (module.hot) {
  module.hot.accept(function (err) {
    if (err) {
      console.error(err);
    }
  });
}